'use strict';

module.exports = root;

var u = require('unist-builder');
var wrap = require('../wrap');
var all = require('../all');

/* Transform a `root`. */
function root(h, node) {
  return h.augment(node, u('root', wrap(all(h, node))));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/root.js
// module id = 996
// module chunks = 0 1